import React from 'react';
import Hero from './components/IQAC/minutes-of-meet/Hero';
import Main from './components/IQAC/minutes-of-meet/Main';

const IqacMinutesofMeet = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default IqacMinutesofMeet;